const yogaStyles = {
    yoga0: {
        name: "Aerial Yoga",
        description: "It is practiced suspended in the air, in a cloth or, sometimes, in a trapeze. This, in addition to being very plastic, facilitates certain postures and makes bending and stretching more profound.",
        benefits: "80% physical, 20% spiritual",
        image: "/images/aerial-yoga.jpg"
    },
    yoga2: {
        name: "Ashtanga Yoga",
        description: "It is a dynamic yoga that provides flexibility and aerobic exercise thanks to a system of synchronized movements and breathing, called vinyasa, which link one position with another.",
        benefits: "80% spiritual, 20% physical",
        image: "/images/ashtanga.jpg"
    },
    yoga3: {
        name: "Bikram Yoga",
        description: "Very demanding from the physical point of view, it is practiced in a heated room, which tries to emulate the conditions of India. It involves 26 postures in a suffocating atmosphere and requires a lot of hydration on the part of the student.",
        benefits: "100% physical",
        image: "/images/bikram.jpg"
    },
    yoga4: {
        name: "Kundalini Yoga",
        description: "It is called the 'yoga of consciousness'. It is physically less demanding than others and seeks to activate the kundalini energy, which resides in the column.In addition to the postures, breathing exercises, mantras, chants and meditation are used.",
        benefits: "80% spiritual, 20% physical",
        image: "/images/kundalini-yoga.jpg"
    },
    yoga5: {
        name: "Nada Yoga",
        description: "It is based on sound. Divide the music into two categories. the internal or anahata and the external or ahata. Through breathing and the use of sounds, the yogi is able to hear his own anahata.",
        benefits: "100% spiritual",
        image: "/images/nada-yoga.jpg"
    },
    yoga6: {
        name: "Vinyasa Yoga",
        description: ":A very vigorous and physically demanding style, in which one moves from one position to the next in a very fluid way.",
        benefits: "100% physical",
        image: "/images/vinyasa.jpeg"
    },
    yoga7: {
        name: "Yin Yoga",
        description: "Yin yoga is a meditative practice that allows your body to become comfortable in a pose without doing any work (strength). It is also called Taoist yoga, and focuses on lengthening the connective tissues within the body",
        benefits: "60% spiritual 40% physical",
        image: "/images/yin-yoga.jpg"
    }
}

export default yogaStyles;